import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {LayoutModule} from '@angular/cdk/layout';
import {SharedModule} from './shared/shared.module';
import {LoginModule} from './login/login.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import {ExportsModule} from './settings/exports/exports.module';
import {SavedReportsModule} from './saved-reports/saved-reports.module';
import {UsersModule} from './settings/users/users.module';
import {ProfileModule} from './settings/profile/profile.module';
import {AdReportsModule} from './reports/ad-reports/ad-reports.module';
import {DimensionsModule} from './settings/dimensions/dimensions.module';
import {MetricsModule} from './settings/metrics/metrics.module';
import {MatchingsModule} from './settings/matchings/matchings.module';
import {ChartReportModule} from './reports/chart-report/chart-report.module';
import {QuickDashboardModule} from './quick-dashboard/quick-dashboard.module';
import {AlertsModule} from "./settings/alerts/alerts.module";
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {appEffects, appReducer} from "./shared/store/store";
import {DashboardReportModule} from './reports/dashboard-report/dashboard-report.module';
import {ChannelAffinityReportModule} from './reports/channel-affinity-report/channel-affinity-report.module';
import {ImageZoomerComponent} from './shared/components/image-zoomer/image-zoomer.component';
import {TimeagoCustomFormatter, TimeagoFormatter, TimeagoIntl, TimeagoModule} from "ngx-timeago";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    ImageZoomerComponent
  ],
  imports: [
    StoreModule.forRoot(appReducer),
    EffectsModule.forRoot(appEffects),
    SharedModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    UsersModule,
    LayoutModule,
    LoginModule,
    ExportsModule,
    SavedReportsModule,
    ProfileModule,
    AdReportsModule,
    DimensionsModule,
    MetricsModule,
    MatchingsModule,
    QuickDashboardModule,
    ChartReportModule,
    DashboardReportModule,
    ChannelAffinityReportModule,
    AlertsModule,
    TimeagoModule.forRoot({
      formatter: { provide: TimeagoFormatter, useClass: TimeagoCustomFormatter },
      intl: { provide: TimeagoIntl },
    })
  ],
  bootstrap: [
    AppComponent,
    ImageZoomerComponent
  ]
})
export class AppModule {
}
